export const pricingData = {
	yearly: [
		{
			title: "Personal",
			features: [
				"Up to 3 Sites",
				"1 Year of Updates",
				"1 Year Free Support",
				"Access to All PRO Features",
			],
			price: "$29",
			salePrice: "$19",
			link: "https://pickplugins.lemonsqueezy.com/buy/78b79f17-1fc4-4e07-9138-1036ee56e269?enabled=248236&checkout%5Bcustom%5D%5Bproduct_id%5D=3815",
		},
		{
			title: "Plus",
			features: [
				"Up to 10 Sites",
				"1 Year of Updates",
				"1 Year Free Support",
				"Access to All PRO Features",
			],
			price: "$75",
			salePrice: "$49",
			link: "https://pickplugins.lemonsqueezy.com/buy/e08a8f55-1a83-46e0-bacb-32cbae536181?enabled=248244&checkout%5Bcustom%5D%5Bproduct_id%5D=93971",
		},

		{
			title: "Agency",
			features: [
				"Up to 500 Sites",
				"1 Year of Updates",
				"1 Year Free Support",
				"Access to All PRO Features",
			],
			price: "$149",
			salePrice: "$99",
			link: "https://pickplugins.lemonsqueezy.com/buy/5c3cdb62-3095-4c15-96e0-00a8776ca58a?enabled=248245&checkout%5Bcustom%5D%5Bproduct_id%5D=93970",
		},
	],
	lifetime: [
		{
			title: "Personal",
			features: [
				"Up to 3 Sites",
				"Lifetime Free Updates",
				"Lifetime Support",
				"Access to All PRO Features",
			],
			price: "$99",
			salePrice: "$49",
			link: "https://pickplugins.lemonsqueezy.com/buy/b6c0aa0f-4793-4ac8-a27a-51c00a9b14cf?enabled=248286&checkout%5Bcustom%5D%5Bproduct_id%5D=37943",
		},
		{
			title: "Plus",
			features: [
				"Up to 10 Sites",
				"Lifetime Free Updates",
				"Lifetime Support",
				"Access to All PRO Features",
			],
			price: "$149",
			salePrice: "$99",
			link: "https://pickplugins.lemonsqueezy.com/buy/54e20160-98ae-4cf6-bd7e-6910c1b8e716?enabled=248291&checkout%5Bcustom%5D%5Bproduct_id%5D=3817",
		},

		{
			title: "Agency",
			features: [
				"Up to 500 Sites",
				"Lifetime Free Updates",
				"Lifetime Support",
				"Access to All PRO Features",
			],
			price: "$199",
			salePrice: "$149",
			link: "https://pickplugins.lemonsqueezy.com/buy/d0041fa6-9c9b-4843-99af-9c213a36c0a6?enabled=248246&checkout%5Bcustom%5D%5Bproduct_id%5D=37944",
		},
	],
};
